/* istanbul ignore file */
import {
  ON_REMOVE_SELECTED_POINTS_FILTER,
  ON_RESTORE_PERIOD,
  ON_AREA_POINT_HOVER,
  ON_SCATTER_POINT_HOVER,
  ON_SCATTER_POINT_CLICK,
  ON_SELECT_MULTIPLE_POINTS,
  ON_SELECT_PERIOD,
  SET_BRANCHES_CYCLE_TIME_STAGES,
  SET_IS_LOADING_SCATTER,
  SET_SCATTER_ENTITIES_IDS,
  SET_METRIC_RAW_EVENTS
} from './actions';
import { getGranularityByPeriod } from './state.utils';
import { last } from 'lodash';

export const generateInitialState = ({ widget, period, filters, isPublic }) => {
  return {
    widget,
    isPublic,
    metricName: widget?.metrics?.[0]?.name || null,
    periods: [period],
    granularity: getGranularityByPeriod(period),
    filters,
    selectedPoints: [],
    scatterEntitiesIds: [],
    metricRawEvents: [],
    isLoadingScatter: true,
    branchesCycleTimeStages: {}
  };
};

const reducer = (state, action) => {
  const lastPeriod = last(state.periods);

  switch (action.type) {
    case ON_SELECT_PERIOD:
      const hasPeriodChanged =
        lastPeriod.before !== action.payload.before ||
        lastPeriod.after !== action.payload.after;

      return hasPeriodChanged
        ? {
            ...state,
            periods: [state.periods[0], action.payload],
            granularity: getGranularityByPeriod(action.payload),
            selectedPoints: []
          }
        : state;

    case ON_RESTORE_PERIOD:
      return {
        ...state,
        periods: [state.periods[0]],
        granularity: getGranularityByPeriod(state.periods[0]),
        selectedPoints: []
      };

    case ON_AREA_POINT_HOVER:
      const areaPoint = action.payload;
      return {
        ...state,
        areaHoveredPoint: areaPoint
      };

    case ON_SCATTER_POINT_CLICK:
      const pointId = action.payload.id;
      const selectedPointsIds = state.selectedPoints.map(point => point.id);
      const updatedSelectedPoints = selectedPointsIds.includes(pointId)
        ? state.selectedPoints.filter(point => point.id !== pointId)
        : [...state.selectedPoints, action.payload];
      return {
        ...state,
        selectedPoints: updatedSelectedPoints
      };

    case ON_SCATTER_POINT_HOVER:
      const point = action.payload;
      return {
        ...state,
        hoveredPoint: point
      };

    case ON_SELECT_MULTIPLE_POINTS:
      return {
        ...state,
        selectedPoints: [
          ...new Set([...state.selectedPoints, ...action.payload])
        ]
      };

    case ON_REMOVE_SELECTED_POINTS_FILTER:
      return {
        ...state,
        selectedPoints: []
      };

    case SET_SCATTER_ENTITIES_IDS:
      return {
        ...state,
        scatterEntitiesIds: action.payload
      };
    case SET_METRIC_RAW_EVENTS:
      return { ...state, metricRawEvents: action.payload };
    case SET_IS_LOADING_SCATTER:
      return {
        ...state,
        isLoadingScatter: action.payload
      };
    case SET_BRANCHES_CYCLE_TIME_STAGES:
      return {
        ...state,
        branchesCycleTimeStages: action.payload
      };
    default:
      return state;
  }
};

export default reducer;
